import { FC } from 'react';
import classNames from 'classnames';

import useScrollListener from '~shared/lib/hooks/useScrollListener';

import { useResolvedMobileAuthTheme } from '~shared/lib/mobile-auth';

import styles from './header.module.scss';

interface SiteHeaderProps {
  children?: React.ReactNode;
}

export const SiteHeader: FC<SiteHeaderProps> = ({ children }) => {
  const scroll = useScrollListener();
  const resolvedTheme = useResolvedMobileAuthTheme();

  const headerClass = classNames(
    styles.wrapper,
    scroll.y > 150 && scroll.y - scroll.lastY > 0 ? styles.hidden : '',
    resolvedTheme === 'dark' ? '!bg-[#000000]' : '!bg-[#ffffff]'
  );

  return (
    <div className={headerClass}>
      <div className={styles.inner}>{children}</div>
    </div>
  );
};
